// @ts-check

/**
 * @typedef {Object} PermissionItem
 * @property {number} id - Уникальный идентификатор элемента.
 * @property {string} name - Название элемента.
 * @property {boolean} selected - Выбран ли элемент.
 * @property {PermissionItem[]=} children - Вложенные элементы (могут отсутствовать).
 */

/**
 * @typedef {Object} GetPermissionsOptions
 * @property {PermissionItem[]} list - Массив объектов с деревом разрешений.
 * @property {number[]} path - Последовательность ID для поиска элемента.
 */

/**
 * Получает значение `selected` у элемента по переданному пути ID.
 *
 * @param {GetPermissionsOptions} options - Объект с параметрами.
 * @returns {boolean | null} - Значение `selected` найденного элемента или `null`, если элемент не найден.
 */
export function getPermissionsMod({ list, path } = {}) {
	/**
	 * Рекурсивный поиск объекта по заданному пути ID.
	 * @param {PermissionItem[]} objects - Список объектов для поиска.
	 * @param {number[]} pathArray - Массив ID, представляющий путь к искомому объекту.
	 * @returns {PermissionItem | null} - Найденный объект или `null`, если не найден.
	 */
	function findObjectByPath(objects, pathArray) {
		if (!Array.isArray(objects) || !pathArray.length) return null;
		let current = objects.find(obj => obj.id === pathArray[0]);

		for (let i = 1; i < pathArray.length; i++) {
			if (!current || !current.children || !Array.isArray(current.children)) return null;
			current = current.children.find(child => child.id === pathArray[i]);
		}

		return current;
	}

	return findObjectByPath(list, path)?.selected ?? null;
}

// const list = this.permissionsDefault;
// const path = [ 98, 91, 92, 72 ];
// const path = [ 98, 91, 92];
// const path = [ 98, 91 ];
// const path = [ 98 ];
// const perm = getPermissionsMod({ list, path });

// const list = this.permissionsDefault;
// const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_COMMENTS, PERMISSIONS.EDIT ];
// const perm = getPermissionsMod({ list, path });

// const list = {
// 	0: {
// 		"id": 89,
// 		"name": "Account",
// 		"selected": true,
// 		"children": [
// 			{
// 				"id": 91,
// 				"name": "Account users",
// 				"selected": true,
// 				"children": [
// 					{
// 						"id": 95,
// 						"name": "My Info",
// 						"selected": false
// 					},
// 					{
// 						"id": 92,
// 						"name": "Account St-ts",
// 						"selected": false,
// 						"children": [
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					},
// 					{
// 						"id": 101,
// 						"name": "Account Comments",
// 						"selected": false,
// 						"children": [
// 							{ "id": 8, "name": "Create", "selected": false },
// 							{ "id": 9, "name": "Edit", "selected": false },
// 							{ "id": 11, "name": "Delete", "selected": false },
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					}
// 				]
// 			},
// 			{
// 				"id": 92,
// 				"name": "Account St-ts",
// 				"selected": false,
// 				"children": [
// 					{ "id": 11, "name": "Delete", "selected": false },
// 					{ "id": 72, "name": "Export", "selected": false }
// 				]
// 			},
// 			{
// 				"id": 101,
// 				"name": "Account Comments",
// 				"selected": false,
// 				"children": [
// 					{ "id": 8, "name": "Create", "selected": false },
// 					{ "id": 9, "name": "Edit", "selected": false },
// 					{ "id": 11, "name": "Delete", "selected": false },
// 					{ "id": 72, "name": "Export", "selected": false }
// 				]
// 			}
// 		]
// 	},
// 	1: {
// 		"id": 891,
// 		"name": "Account1",
// 		"selected": true,
// 		"children": [
// 			{
// 				"id": 911,
// 				"name": "Account users1",
// 				"selected": true,
// 				"children": [
// 					{
// 						"id": 951,
// 						"name": "My Info1",
// 						"selected": false
// 					},
// 					{
// 						"id": 921,
// 						"name": "Account St-ts1",
// 						"selected": false,
// 						"children": [
// 							{ "id": 8, "name": "Create", "selected": false },
// 							{ "id": 9, "name": "Edit", "selected": false },
// 							{ "id": 11, "name": "Delete", "selected": false },
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					},
// 					{
// 						"id": 1011,
// 						"name": "Account Comments1",
// 						"selected": false,
// 						"children": [
// 							{ "id": 8, "name": "Create", "selected": false },
// 							{ "id": 9, "name": "Edit", "selected": false },
// 							{ "id": 11, "name": "Delete", "selected": false },
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					}
// 				]
// 			},
// 			{
// 				"id": 912,
// 				"name": "Account users2",
// 				"selected": true,
// 				"children": [
// 					{
// 						"id": 952,
// 						"name": "My Info2",
// 						"selected": false
// 					},
// 					{
// 						"id": 922,
// 						"name": "Account St-ts2",
// 						"selected": false,
// 						"children": [
// 							{ "id": 8, "name": "Create", "selected": false },
// 							{ "id": 9, "name": "Edit", "selected": false },
// 							{ "id": 11, "name": "Delete", "selected": false },
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					},
// 					{
// 						"id": 1012,
// 						"name": "Account Comments2",
// 						"selected": false,
// 						"children": [
// 							{ "id": 8, "name": "Create", "selected": false },
// 							{ "id": 9, "name": "Edit", "selected": false },
// 							{ "id": 11, "name": "Delete", "selected": false },
// 							{ "id": 72, "name": "Export", "selected": false }
// 						]
// 					}
// 				]
// 			}
// 		]
// 	}
// };
